import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Heading, F0Text } from '@factorialco/f0-react'

export interface WizardStepLayoutF0Props {
  children?: React.ReactNode
  title: string
  subtitle?: string
}

export const WizardStepLayoutF0 = ({ title, subtitle, children }: WizardStepLayoutF0Props) => {
  return (
    <Box flexDirection="column" gap="s24" width="full">
      <Box flexDirection="column" gap="s8" style={{ maxWidth: '500px' }}>
        <F0Heading variant="heading-large" content={title} />
        {subtitle && <F0Text variant="body" content={subtitle} />}
      </Box>
      {children}
    </Box>
  )
}
